/**
 * P3-35: SpacePanel —— Space tab 折叠面板（迁移自
 * com.nuclearunicorn.game.ui.Panel，core.js:2497-2603）。
 *
 * 逐结构对齐旧 Panel：
 * - 根 div.panelContainer（display 由 visible 控制）
 * - div.toggle（float:right、tabIndex=0、"+"/"-"、collapsed class）
 * - div.title（面板名称）
 * - div.container（display 由 collapsed 控制）
 *
 * 折叠态为组件内部 state，不持久化（与旧版一致）。
 */
import { useState, type ReactNode } from "react";

export interface SpacePanelProps {
  /** 面板标题（旧 Panel.name），支持 ReactNode 以便动态 ETA */
  title: ReactNode;
  /** 是否渲染面板 */
  visible?: boolean;
  children?: ReactNode;
}

export function SpacePanel({ title, visible = true, children }: SpacePanelProps) {
  const [collapsed, setCollapsed] = useState(false);

  if (!visible) {
    return null;
  }

  return (
    <div className="panelContainer">
      <div
        className={"toggle" + (collapsed ? " collapsed" : "")}
        tabIndex={0}
        style={{ float: "right" }}
        onClick={() => setCollapsed(!collapsed)}
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            setCollapsed(!collapsed);
          }
        }}
      >
        {collapsed ? "+" : "-"}
      </div>
      <div className="title">{title}</div>
      <div className="container" style={{ display: collapsed ? "none" : "" }}>
        {children}
      </div>
    </div>
  );
}
